// extracted by mini-css-extract-plugin
module.exports = {"navigation-component":"styles-m__navigation-component__3rUzI"};